import { render, staticRenderFns } from "./error.vue?vue&type=template&id=5f102266&scoped=true"
import script from "./error.vue?vue&type=script&lang=js"
export * from "./error.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/error.scss?vue&type=style&index=0&id=5f102266&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f102266",
  null
  
)

export default component.exports